import * as types from './types'

export const mutations = {
	[types.ADD_SUBSCRIPTION] (state, subscription) {
		state.subscriptions.push(subscription)
	},
	[types.REPLACE_SUBSCRIPTION] (state, subscription) {
		state.subscriptions = state.subscriptions.map((op) => {
			if (op.id !== subscription.id) {
				return op
			} else {
				return subscription
			}
		})
	},
	[types.CLEAR_SUBSCRIPTIONS] (state) {
		state.subscriptions = []
	},
	[types.LAST_PAYMENT_FAIL_INFO] (state, info) {
		state.lastPaymentFailInfo = info
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Subscriptions/mutations.js